import { PIE_CONFIG, LABEL_CONFIG } from '../constants';
import { calculateLabelPosition } from './pieChartUtils';

export const createLabelRenderer = (activeIndex: number | undefined) => {
	return (props: any) => {
		const { cx, cy, midAngle, innerRadius, outerRadius, percent, index } = props;

		if (activeIndex === index) return null;
		if (percent < PIE_CONFIG.minPercentForLabel) return null;

		const { x, y } = calculateLabelPosition(cx, cy, midAngle, innerRadius, outerRadius);

		return (
			<text
				x={x}
				y={y}
				fill={LABEL_CONFIG.fill}
				textAnchor="middle"
				dominantBaseline="central"
				fontSize={LABEL_CONFIG.fontSize}
				fontWeight={LABEL_CONFIG.fontWeight}
				fontFamily={LABEL_CONFIG.fontFamily}
			>
				{`${(percent * 100).toFixed(0)}%`}
			</text>
		);
	};
};
